// Button.jsx
import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

const CustomButton = ({ onClick, children, style, variant = 'primary', theme = 'light', disabled = false, ...props }) => {
    const isDark = theme === 'dark';
    
    // Define colors based on variant and theme
    const getButtonColors = () => {
        if (disabled) {
            return {
                backgroundColor: isDark ? '#444' : '#e9ecef',
                borderColor: isDark ? '#555' : '#dee2e6',
                color: isDark ? '#888' : '#6c757d',
            };
        }
        
        switch (variant) {
            case 'primary':
                return {
                    backgroundColor: '#007bff',
                    borderColor: '#007bff',
                    color: '#ffffff',
                    hover: {
                        backgroundColor: '#0056b3',
                        borderColor: '#004085',
                    }
                };
            case 'secondary':
                return {
                    backgroundColor: isDark ? '#6c757d' : '#6c757d',
                    borderColor: isDark ? '#6c757d' : '#6c757d',
                    color: '#ffffff',
                    hover: {
                        backgroundColor: isDark ? '#545b62' : '#545b62',
                        borderColor: isDark ? '#4e555b' : '#4e555b',
                    }
                };
            case 'success':
                return {
                    backgroundColor: '#28a745',
                    borderColor: '#28a745',
                    color: '#ffffff',
                    hover: {
                        backgroundColor: '#1e7e34',
                        borderColor: '#1c7430',
                    }
                };
            case 'danger':
                return {
                    backgroundColor: '#dc3545',
                    borderColor: '#dc3545',
                    color: '#ffffff',
                    hover: {
                        backgroundColor: '#c82333',
                        borderColor: '#bd2130',
                    }
                };
            default:
                return {
                    backgroundColor: isDark ? '#495057' : '#f8f9fa',
                    borderColor: isDark ? '#6c757d' : '#dee2e6',
                    color: isDark ? '#ffffff' : '#212529',
                    hover: {
                        backgroundColor: isDark ? '#5a6268' : '#e2e6ea',
                        borderColor: isDark ? '#6c757d' : '#dae0e5',
                    }
                };
        }
    };

    const colors = getButtonColors();

    return (
        <BootstrapButton
            onClick={onClick}
            disabled={disabled}
            style={{
                backgroundColor: colors.backgroundColor,
                borderColor: colors.borderColor,
                color: colors.color,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '50px',
                padding: '0.5rem 1rem',
                textAlign: 'center',
                border: '1px solid',
                borderRadius: '6px',
                fontSize: '0.9rem',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                cursor: disabled ? 'not-allowed' : 'pointer',
                ...style,
            }}
            onMouseEnter={(e) => {
                if (!disabled && colors.hover) {
                    e.target.style.backgroundColor = colors.hover.backgroundColor;
                    e.target.style.borderColor = colors.hover.borderColor;
                }
            }}
            onMouseLeave={(e) => {
                if (!disabled) {
                    e.target.style.backgroundColor = colors.backgroundColor;
                    e.target.style.borderColor = colors.borderColor;
                }
            }}
            {...props}
        >
            {children}
        </BootstrapButton>
    );
};

export default CustomButton;
